module.exports = __webpack_public_path__ + "static/media/img91_R.c6789d06.jpg";